import React from 'react'

interface Props {
    title: string;
    image: Image;
    width?: string;
    ratio?: string;
}
interface Image {
    url: string;
}

function ArticleThumbnail(props: Props) {
    const { title, image, width, ratio = '1/1' } = props
    const containerStyle: React.CSSProperties = {
      aspectRatio: ratio,
      width: `${width}`,
    };
    const imageClass = `w-full h-full object-cover`

    return (
        <div style={containerStyle}> 
            <img src={image.url} alt={title} className={imageClass} />
        </div>
    )
}

export default ArticleThumbnail